import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api`;

export const requestPasswordReset = async (identifier) => {
  const res = await axios.post(`${API}/password-reset/request`, { identifier });
  return res.data;
};

export const sendVerificationCode = async (identifier, method) => {
  const params = new URLSearchParams();
  params.append('identifier', identifier);
  params.append('method', method);
  const res = await axios.post(`${API}/password-reset/send-code`, params);
  return res.data;
};

export const verifyResetCode = async (identifier, verification_code) => {
  const res = await axios.post(`${API}/password-reset/verify-code`, { identifier, verification_code });
  return res.data;
};

export const updateFounderPassword = async (identifier, verification_code, new_password) => {
  const res = await axios.post(`${API}/password-reset/update-password`, { identifier, verification_code, new_password });
  return res.data;
};

// Nouveau: demande de lien de réinitialisation (réponse générique si compte inexistant)
export const requestPasswordResetLink = async (email) => {
  const res = await axios.post(`${API}/password-reset/request-link`, null, { params: { email } });
  return res.data;
};

// Nouveau: consommation du lien de réinitialisation
export const consumePasswordResetLink = async (token, email, new_password) => {
  const res = await axios.post(`${API}/password-reset/consume-link`, { token, email, new_password });
  return res.data;
};